import React from 'react';
import PropTypes from 'prop-types';
import Header from './Header';
import Body from './Body';
import Footer from './Footer';
import { LayoutContainer } from './containers';

export default function Layout({ headerName, children }) {
  return (
    <React.Fragment>
      <LayoutContainer>
        <Header headerName={headerName} />
        <Body>{children}</Body>
        <Footer />
      </LayoutContainer>
    </React.Fragment>
  );
}

Layout.propTypes = {
  /* Name used in H2 header */
  headerName: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/ui/layout/index.js